import * as React from 'react';
import styled from 'styled-components';
import Title from '../title/Title';
import { getFullIconsName } from '../../constants/iconsName';

// ############################ Styles ###########################
// tslint:disable:variable-name

function beforeStyle(icon) {
  if (icon) {
    return `
    &:before {
      content: '';
      background: url(${icon}) no-repeat;
      left: -20px;  
      width: 24px;
      height: 24px;
      position: absolute;
    }
    `;
  }

  return '';
}
const SFooterContainer = styled.div(({ theme }) => {
  return `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `;
});
const STitle = styled(Title)(({ theme }) => {
  return `
  @media only screen and ${theme.device.max.mobileL} {
    font-size: ${theme.font.size.medium2};
    margin-bottom: 3px;
  }
  `;
});

const SFooterContactText = styled.div<{ icon: string }>(({ theme, icon }) => {
  return `
  font-size: ${theme.font.size.smallMedium2};
  font-weight: ${theme.font.weight.light};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${theme.colors.grayLight2};
  position: relative;
  padding-left: ${theme.spacing.medium}px;
  text-align: center;

  ${beforeStyle(icon)}
  
  @media only screen and ${theme.device.max.mobileL} {
    font-size: ${theme.font.size.smallMedium};
  }

  `;
});

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface IFooterProps {
  phoneNumber: string;
  emailAddress: string;
  dataAt: string;
  openingHours: string;
}

export default ({ phoneNumber, emailAddress, dataAt, openingHours }: IFooterProps) => {
  return (
    <SFooterContainer>
      <STitle size={'large'} dataAt={dataAt}>
        Contact Us
      </STitle>

      <SFooterContactText icon={getFullIconsName['email']}>{emailAddress}</SFooterContactText>
      <SFooterContactText icon={getFullIconsName['phone']}>{phoneNumber}</SFooterContactText>
      <SFooterContactText icon={''}>{openingHours}</SFooterContactText>
    </SFooterContainer>
  );
};
